@if (data) {
  @switch (data.layout) {
    @case (layout.LAYOUT1) {
      <app-gallery-layout-1 [data]="data.data" />
    }
    @case (layout.LAYOUT2) {
      <app-gallery-layout-2 />
    }
    @case (layout.LAYOUT3) {
      <app-gallery-layout-3 [data]="data.data" />
    }
    @case (layout.LAYOUT4) {
      <app-gallery-layout-4 [data]="data.data" />
    }
    @case (layout.LAYOUT5) {
      <app-gallery-layout-5 [data]="data.data" />
    }
    @case (layout.LAYOUT6) {
      <app-gallery-layout-6 [data]="data.data" />
    }
    @case (layout.LAYOUT7) {
      <app-gallery-layout-7 [data]="data.data" />
    }
    @case (layout.LAYOUT8) {
      <app-gallery-layout-8 [data]="data.data" />
    }
    @case (layout.LAYOUT9) {
      <app-gallery-layout-9 [data]="data.data" />
    }
    @case (layout.LAYOUT10) {
      <app-gallery-layout-10 [data]="data.data" />
    }
    @case (layout.LAYOUT11) {
      <app-gallery-layout-11 [data]="data.data" />
    }
    @case (layout.LAYOUT12) {
      <app-gallery-layout-12 [data]="data.data" />
    }
    @case (layout.LAYOUT13) {
      <app-gallery-layout-13 [data]="data.data" />
    }
    @case (layout.LAYOUT14) {
      @defer (on immediate) {
        <app-gallery-layout-14 />
      }
    }
    @case (layout.LAYOUT15) {
      <app-gallery-layout-15 [data]="data.data" />
    }
    @case (layout.LAYOUT16) {
      <app-gallery-layout-16 [data]="data.data" />
    }
  }
}
